import { Flex, Typography } from 'antd';
import { type ReactNode, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomerOrderForm from './customer-order.form';
import LoadingSpin from '../../../../components/loading-spin';
import SyncSuspense from '../../../../components/sync-suspense';
import { CustomerOrder } from '../../../../entities';
import useCustomerOptions from '../../../../hooks/use-customer-options';
import useCustomerOrderDetail from '../../../../hooks/use-customer-order-detail';
import useErrorNotification from '../../../../hooks/use-error-notification';
import useWarnBeforeUnload from '../../../../hooks/use-warn-before-unload';

const ORDERS_PAGE_URL = '/orders';
const NOT_FOUND_STATUS = 404;

const CustomerOrderUpdateFormPage = (): ReactNode => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const customers = useCustomerOptions();
  const customerOrder = useCustomerOrderDetail(orderId);
  useErrorNotification(customers.errorMessage);
  useErrorNotification(customerOrder.errorMessage);
  useWarnBeforeUnload();

  useEffect(() => {
    if (customerOrder.errorStatus === NOT_FOUND_STATUS) {
      navigate(ORDERS_PAGE_URL);
    }
  }, [customerOrder.errorStatus]);

  return (
    <Flex vertical>
      <Typography.Title level={2}>Update order #{orderId}</Typography.Title>
      <SyncSuspense
        fallback={<LoadingSpin />}
        condition={!customerOrder.isLoading && !customers.isLoading}
      >
        <CustomerOrderForm
          customerOrder={customerOrder.data ?? new CustomerOrder()}
          customers={customers.data ?? []}
        />
      </SyncSuspense>
    </Flex>
  );
};

export default CustomerOrderUpdateFormPage;
